import { observable, runInAction, action, makeObservable } from 'mobx';

import API from 'utils/api';

import { DeviceAnalyticsType } from 'utils/api/modules/devices/devices.types';

import { formatFullDate } from 'utils/formatters/time';

import RootStore from '../Root';

export default class MobileAnalytics {
  @observable deviceAnalytics: DeviceAnalyticsType[] = [];

  isAnalyticsDataLoaded = false;

  rootStore: RootStore;

  api: typeof API;

  constructor(rootStore: RootStore, api: typeof API) {
    makeObservable(this);
    this.api = api;
    this.rootStore = rootStore;
  }

  async loadData(): Promise<void> {
    if (!this.isAnalyticsDataLoaded) {
      this.loadDeviceAnalytics();
      this.isAnalyticsDataLoaded = true;
    }
  }

  @action.bound
  async loadDeviceAnalytics(): Promise<void> {
    const afterDate = new Date(new Date().setDate(new Date().getDate() - 30));

    const { data } = await this.api.devices.loadDeviceAnalytics({
      date_after: formatFullDate(afterDate),
      type: 'mobile',
    })();
    runInAction(() => {
      this.deviceAnalytics = data;
    });
  }
}
